module.exports = __webpack_public_path__ + "img/9791196149963.533224ad.jpg";